import { render, staticRenderFns } from "./UiModalFullSize.vue?vue&type=template&id=1ce41219&"
import script from "./UiModalFullSize.vue?vue&type=script&lang=js&"
export * from "./UiModalFullSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports